import { withInstall } from '@vuemap/vue-amap-util'
import Circle from './Circle.vue'

export const ElAmapCircle = withInstall(Circle)
export default ElAmapCircle
